/**
 * @fileoverview PHARMAKON — Cross-module X · Caisse libre windows API (brief §10; XWP-02 / XWP-18)
 * @module services/caisse-fenetre.api
 *
 * The server holds every window and its stock reservations; the SPA calls one small endpoint per
 * line / header change (never the full basket) and switches windows without any request
 * (02_DESIGN §4.1, XA-08). The optimistic version travels in `If-Match` (required on the header
 * checkpoint and on the validation, optional on line operations).
 */
import api from "./api.client.js";

const BASE = "/caisse/fenetres";
const avecVersion = (version) => (version == null ? undefined : { headers: { "If-Match": String(version) } });

export const caisseFenetreApi = {
  /** Open the caissier login session: window 1; releases a previous session's windows (XD-39). */
  ouvrirSession: () => api.post(`${BASE}/session`, {}),
  /** Logout: the session's windows release their holds. */
  fermerSession: (session_poste_id) => api.post(`${BASE}/session/fermer`, { session_poste_id }),
  /** The session's ACTIVE windows, recently expired ones and whether the session is current. */
  lister: (session_poste_id) => api.get(BASE, { params: { session_poste_id } }),
  /** One own window (any statut). */
  obtenir: (id) => api.get(`${BASE}/${id}`),
  /** F3 « Nouvelle fenêtre (client suivant) ». */
  ouvrir: (session_poste_id, client_id = null) => api.post(BASE, { session_poste_id, ...(client_id ? { client_id } : {}) }),
  /** Header checkpoint: client, remise, notes, médecin, source prescription, Aalaji pickup order. */
  checkpoint: (id, changements, version) => api.patch(`${BASE}/${id}`, changements, avecVersion(version)),
  /** Maj+Suppr « Fermer la fenêtre » — or the hand-off to Vente CHIFA: its holds are released. */
  fermer: (id) => api.delete(`${BASE}/${id}`),
  /** Add a line: holds FEFO / the explicit lot; a secours line holds nothing. */
  ajouterLigne: (id, ligne) => api.post(`${BASE}/${id}/lignes`, ligne),
  /** Commit a line change: quantité, lot (F7), ordonnancier / posologie / durée. */
  modifierLigne: (id, cle, changements) => api.patch(`${BASE}/${id}/lignes/${encodeURIComponent(cle)}`, changements),
  /** Suppr — remove a line and release its holds. */
  supprimerLigne: (id, cle) => api.delete(`${BASE}/${id}/lignes/${encodeURIComponent(cle)}`),
  /** F9 then the outcome: COMPTANT (méthode, référence, carte fidélité) or CREDIT. */
  valider: (id, corps, version) => api.post(`${BASE}/${id}/valider`, corps, avecVersion(version)),
  /** « Ventes en attente » — resume an EN_COURS draft into this empty window (XD-46). */
  reprendreVente: (id, vente_id) => api.post(`${BASE}/${id}/reprendre-vente`, { vente_id }),
  /**
   * X §8.1 (XWP-22) — « Envoyer vente libre »: the instance's lines enter this window, locked (its lots
   * and quantities, nothing held). 409 with `details.verification` when a line stops the conversion.
   */
  importerInstance: (id, instance_id) => api.post(`${BASE}/${id}/importer-instance`, { instance_id }),
};

export default caisseFenetreApi;
